import React from "react";
import "./JobListPage.css";
import { FaMoneyBillWave, FaMapMarkerAlt, FaClock } from "react-icons/fa";

const JobCard = ({ job, onClick }) => {
  return (
    <div className="job-card" onClick={onClick}>
      <div className="job-meta">{job.postedDate}</div>
      <h3>{job.title}</h3>
      <div className="job-details"> 
      <p><FaMoneyBillWave className="icon" /> {job.salary}</p>
      <p><FaMapMarkerAlt className="icon" /> {job.location}</p>
      <p><FaClock className="icon" /> {job.type}</p>
      </div >
      <div className="job-summary">
      <p>{job.summary}</p>
      </div>
    </div>
  );
};

export default JobCard;
